import list from 'src/modules/producer/list/producerListReducers';
import form from 'src/modules/producer/form/producerFormReducers';
import view from 'src/modules/producer/view/producerViewReducers';
import destroy from 'src/modules/producer/destroy/producerDestroyReducers';
import importerReducer from 'src/modules/producer/importer/producerImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
